"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.GridRow = exports.CloseButton = exports.CheckboxStyled = exports.MaskInputStyled = exports.RadioStyled = exports.DatePickerStyled = exports.SelectStyled = exports.InputStyled = exports.FormItemFormulary = exports.ColStyled = exports.Text = exports.Group = exports.Container = void 0;
const antd_1 = require("antd");
const antd_mask_input_1 = __importDefault(require("antd-mask-input"));
const styled_components_1 = __importStar(require("styled-components"));
const mobileWidth = '992px';
exports.Container = styled_components_1.default.div `
  padding: 0 2%;
  @media (max-width: ${mobileWidth}) {
    #title,
    #underline {
      display: none;
    }
    #mobile-subtitle {
      font-weight: normal !important;
    }

    span {
      font-size: 16px;
    }
    #password-section {
      & > span:first-child {
        font-size: 22px !important;
      }
      & > div {
        margin: 15px 0 20px;
      }
      .mobile-order {
        display: flex;
        flex-direction: column-reverse;
        .delete-account {
          display: flex;
          flex-direction: column;
          span:first-child {
            margin-bottom: 20px !important;
          }
          span:nth-child(2) {
            margin: 0 0 50px !important;
          }
        }
        .ant-btn {
          margin: 0 !important;
          width: 100%;
          max-width: 100%;
          height: 53px;
          margin-bottom: 38px !important;
        }
      }
    }
  }
  @media (min-width: ${mobileWidth}) {
    .mobile-divider {
      display: none !important;
    }
  }
`;
exports.Group = styled_components_1.default.div `
  margin-top: 5px;
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  flex-wrap: wrap;
  #datePicker {
    position: relative;
  }
  &[id='email'] {
    :nth-child(2) {
      justify-content: flex-start;
    }
  }
  .emailForm {
    width: 100%;
  }
  ${(props) => props.wrapper
    ? (0, styled_components_1.css) `
          flex-direction: row;
          width: 100%;
          @media screen and (max-width: 700px) {
            flex-direction: column;
            align-items: flex-start;
          } ;
        `
    : (0, styled_components_1.css) `
          flex-direction: column;
          width: 48%;
          @media screen and (max-width: 700px) {
            width: 100%;
          } ;
        `};
`;
exports.Text = styled_components_1.default.span `
  ${props => (0, styled_components_1.css) `
    color: ${props.color || '#000'};
    font-weight: ${props.decoration || 'normal'};
    font-size: ${(props.size && (props.size - 5) * 0.06) || 14 * 0.06}rem;
    cursor: ${props.clickable ? 'pointer' : 'default'};
    @media screen and (max-width: ${mobileWidth}) {
      font-size: ${(props.size && (props.size - 7) * 0.06) || 13 * 0.06}rem;
    }
  `}
`;
exports.ColStyled = (0, styled_components_1.default)(antd_1.Col) `
  margin-top: 10px;
`;
exports.FormItemFormulary = (0, styled_components_1.default)(antd_1.Form.Item) `
  label {
    color: #000;
    font-weight: 500;
  }
`;
exports.InputStyled = (0, styled_components_1.default)(antd_1.Input) `
  border-radius: 5px;
  height: 43px;
  width: 100%;

  &[type='number']::-webkit-inner-spin-button,
  &[type='number']::-webkit-outer-spin-button {
    -webkit-appearance: none !important;
    margin: 0 !important;
  }
  @media (max-width: ${mobileWidth}) {
    height: 53px;
  }
`;
exports.SelectStyled = (0, styled_components_1.default)(antd_1.Select) `
  width: 100%;
  border-radius: 5px;
  height: 43px;
  .ant-select-selector {
    border-radius: 5px !important;
  }
  @media (max-width: ${mobileWidth}) {
    &,
    .ant-select-selector {
      height: 53px !important;
    }
  }
`;
exports.DatePickerStyled = (0, styled_components_1.default)(antd_1.DatePicker) `
  width: 100%;
  height: 43px;
  border-radius: 5px;
  @media (max-width: ${mobileWidth}) {
    height: 53px;
  }
`;
exports.RadioStyled = (0, styled_components_1.default)(antd_1.Radio.Group) `
  height: 43px;
  display: flex;
  align-items: center;
  flex-wrap: wrap;
`;
exports.MaskInputStyled = (0, styled_components_1.default)(antd_mask_input_1.default) `
  border-radius: 5px;
  height: 43px;
  @media (max-width: ${mobileWidth}) {
    & * {
      font-size: 16px;
    }
    height: 53px !important;
  }
`;
exports.CheckboxStyled = (0, styled_components_1.default)(antd_1.Checkbox) `
  display: flex;
  margin: 5px 0 !important;
  .ant-checkbox-inner {
    width: 20px;
    height: 20px;
  }

  a {
    color: #000;
    text-decoration: underline;
  }
`;
exports.CloseButton = styled_components_1.default.span `
  position: absolute;
  right: 0;
  top: 0;
`;
exports.GridRow = styled_components_1.default.div `
  position: relative;
  display: grid;
  grid-template-columns: 50% 25%;
  transition: 0.5s;
  width: 100%;
  &#email {
    grid-template-columns: 45% 30%;
    width: 100%;
  }
  @media screen and (max-width: ${mobileWidth}) {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    &#email {
      display: flex;
      flex-direction: column;
      width: 100%;
      .ant-row,
      .ant-form-item {
        width: 100%;
      }
    }
  }
`;
